exports.lang = {
    "kr": "zh",
    "아프리카TV | 투표" : "AfreecaTV ㅣ 投票",
    "투표" : "投票",
    "투표 등록" : "制作新投票",
    "투표 수정" : "修改",
    "투표 등록 및 수정" : "制作并修改投票",
    "종류" : "分类",
    "기본형" : "基本型",
    "1:1 투표" : "1对1投票",
    "제목" : "标题",
    "투표 제목을 입력해주세요." : "请输入标题。",
    "항목을 입력해주세요." : "请输入选项内容。",
    "기간" : "期间",
    "투표 종료일" : "投票截止日",
    "종료일" : "截止日",
    "설정" : "设定",
    "복수 선택 허용" : "可多选",
    "결과 미리보기 허용" : "允许预览结果",
    "체크 박스를 해제하시면 투표에 참여하기 전 또는 투표가 종료될 때까지 모든 참여자가 투표 결과를 확인할 수 없습니다." : "解除此选项，参与投票前或投票结束之前，所有用户无法确认投票结果。",
    "수정" : "修改",
    "닫기" : "关闭",
    "삭제" : "删除",
    "등록" : "制作",
    "투표 항목을 입력해주세요." : "请输入选项内容。",
    "투표 항목은 최소 2개 이상 등록해야 합니다." : "选项不能少于两个。",
    "투표는 최대 3개까지 등록할 수 있습니다." : "同时最多可进行3个投票。",
    "투표 항목은 최대 10개까지 만들 수 있습니다." : "投票选项不能超过10个。",
    "투표 제목은 최대 30자까지 입력할 수 있습니다." : "标题字数不能超过30字。",
    "투표 항목은 최대 10자까지 입력할 수 있습니다." : "选项内容不能超过10字。",
    "올바른 파일 형식이 아닙니다.\n파일 확장명이 JPG, GIF 인지 다시 확인해주세요." : "文件格式有误。请确认文件扩展名是否为JPG, GIF后重新尝试。",
    "파일 용량이 10MB을(를) 초과하여 등록할 수 없습니다." : "文件大小不能超过10MB。",
    "선택하신 GIF 파일 용량이 200KB를 초과하여 등록할 수 없습니다. 파일 용량을 다시 확인해주세요." : "GIF附件容量超过20KB，不能上传。请您重新确认文件大小。",
    "투표 기간을 설정해주세요." : "请设定投票期间。",
    "오늘보다 이전 날짜 또는 시간은 설정할 수 없습니다." : "不能设定过去的时间。",
    "입력하신 내용이 모두 초기화됩니다. 투표 형식을 변경하시겠습니까?" : "如要继续，您输入的所有内容都将被初始化。确定更改投票的形式吗？",
    "투표가 수정되었습니다." : "修改成功。",
    "투표를 삭제하시겠습니까?" : "确定要删除投票吗？",
    "해당 투표 항목을 삭제하시겠습니까?" : "确定删除此选项吗？",
    "투표하기" : "投票",
    "결과 미리보기" : "预览结果",
    "다시 투표하기" : "重新投票",
    "전체 참여자" : "累计参与",
    "명" : "",
    "투표하러 가기" : "去投票",
    "현재시간 이후를 선택해주세요." : "请选择此刻以后的时间。",
    "투표 종료일을 3개월 이내로 선택해주세요." : "请选择自投票开始后3月内的投票截止日期。",
    "투표가 등록되었습니다." : "新一轮投票开始。",
    "투표를 등록한 유저가 삭제한 투표입니다." : "此投票已被制作投票的用户删除。",
    "다른 투표에 참여해주세요." : "请参与其他投票。",
    "투표에 참여 완료되었습니다." : "参与成功。",
    "투표 종료" : "投票结束",
    "투표를 종료하시겠습니까?" : "确定结束投票吗？",
    "항목 추가" : "添加选项",
    "취소" : "取消",
    "시" : "时",
    "분" : "分",
    "이미지 1:1 투표 등록 시, 투표 이미지를 모두 첨부하셔야 등록할 수 있습니다.": "进行1:1图片投票时，必须添加所有图片。",
    "무승부" : "领带",
    "무승부 항목 추가" : "添加平局",
}